import { PropsWithChildren, ReactElement } from 'react';

import classNames from 'classnames';

import { FormControl, FormControlBaseProps } from '../FormControl';

import { FormRadioToggleValidation } from './FormRadioToggle.types';
import { FormRadioToggleItem } from './FormRadioToggleItem/FormRadioToggleItem';
import { FormRadioToggleContext } from './FormRadioToggle.context';

import styles from './FormRadioToggle.module.scss';

interface FormRadioToggleProps
  extends FormControlBaseProps<FormRadioToggleValidation> {
  direction?: 'row' | 'column';
  spacing: 'none' | 'sm';
}

interface FormRadioToggleComponent {
  (props: PropsWithChildren<FormRadioToggleProps>): ReactElement;
  Item: typeof FormRadioToggleItem;
}

export const FormRadioToggle: FormRadioToggleComponent = ({
  children,
  spacing = 'none',
  direction = 'column',
  ...props
}) => {
  return (
    <FormControl
      variant="default"
      type="radioToggle"
      className={styles.control}
      {...props}
    >
      {({ value, onChange }) => {
        return (
          <FormRadioToggleContext.Provider value={{ value, onChange }}>
            <div
              className={classNames(styles.root, styles[direction], {
                [styles.spacingSm]: spacing === 'sm',
              })}
            >
              {children}
            </div>
          </FormRadioToggleContext.Provider>
        );
      }}
    </FormControl>
  );
};

FormRadioToggle.Item = FormRadioToggleItem;
